var map = {
	"./Green-VeryLow.png": 995,
	"./Green-VeryLow.svg": 2401,
	"./Red-Excessive.png": 991,
	"./Red-Excessive.svg": 2402,
	"./RedYellow-Significant.png": 992,
	"./RedYellow-Significant.svg": 2403,
	"./White-Unknown.png": 599,
	"./White-Unknown.svg": 2404,
	"./Yellow-Moderate.png": 993,
	"./Yellow-Moderate.svg": 2405,
	"./YellowGreen-Low.png": 994,
	"./YellowGreen-Low.svg": 2406
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2400;


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map ^\.\/.*$
// module id = 2400
// module chunks = 1